/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2018 MDL Online (https://mdlonline.nl)
 * @package MDLOnline_base
 */

define([
    'headroom',
    'domReady!'
], function (Headroom) {
    "use strict";

    const header = document.querySelector(".page-header"),
        headerHeight = header.clientHeight,
        windowHeight = window.outerHeight,
        combinedHeight = Math.round((headerHeight + windowHeight) * 1.1),
        documentHeight = document.documentElement.scrollHeight,
        addToCart = document.querySelector(".product-info-main"),
        cartSummary = document.querySelector(".cart-summary");

    // Only fire Headroom if the header + the height of the window (plus 10%)
    // is lower than the height of the entire document. This prevents jumping on short pages.
    if (combinedHeight < documentHeight) {

        // Get original 'top' css value from add to cart block
        let originalOffset = void 0,
            stickyElement = void 0;

        if (addToCart != null) {
            stickyElement = addToCart;
            originalOffset = parseInt(window.getComputedStyle(addToCart).top);
        } else if (cartSummary != null) {
            stickyElement = cartSummary;
            originalOffset = parseInt(window.getComputedStyle(cartSummary).top);
        }

        // Add header height to original offset to 'top' css value
        const adjustAddToCart = () => {
            if (stickyElement == null) {
                return;
            }

            const newTop = originalOffset + header.clientHeight;

            stickyElement.style.top = newTop + 'px';
        };

        // Reset 'top' css value to initial
        const resetAddToCart = () => {
            if (stickyElement == null) {
                return;
            }

            stickyElement.style.top = originalOffset + 'px';
        };

        // construct an instance of Headroom, passing the element
        const headroom = new Headroom(header, {
            // tolerance for up/down scroll
            tolerance: {
                up: 20,
                down: 0
            },
            // css classes to apply
            classes: {
                // when element is initialised
                initial: "scrollback",
                // when scrolling up
                pinned: "scrollback--pinned",
                // when scrolling down
                unpinned: "scrollback--unpinned",
                // when above offset
                top: "scrollback--top",
                // when below offset
                notTop: "scrollback--not-top",
                // when at bottom of scoll area
                bottom: "scrollback--bottom",
                // when not at bottom of scroll area
                notBottom: "scrollback--not-bottom"
            },
            // callback when pinned, `this` is headroom object
            onPin: function onPin() {
                adjustAddToCart();
            },
            // callback when unpinned, `this` is headroom object
            onUnpin: function onUnpin() {
                resetAddToCart();
            },
            // callback when below offset, `this` is headroom object
            onNotTop: function onNotTop() {
                adjustAddToCart();
            }
        });

        // Don't initialise on checkout page
        if (!document.body.classList.contains('checkout-index-index')) {
            // initialise
            headroom.init();
        }
    }
});
